/**
 * Spec Phase 4 Slice 4D — CompletenessBar.
 *
 * Overall completeness % at the bottom of the left rail. The integer
 * comes from spec_documents.overall_completeness_pct (computed in
 * compute_overall_completeness, which divides drafted non-auto
 * sections by total non-auto sections × 100).
 */
import React from 'react';

interface Props {
  pct: number; // 0..100
}

export default function CompletenessBar({ pct }: Props): JSX.Element {
  const clamped = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <div
      className="border-t border-zinc-200 px-3 py-3"
      data-testid="spec-completeness-bar"
    >
      <div className="mb-1 flex items-center justify-between">
        <span className="text-[11px] font-medium uppercase tracking-wide text-zinc-500">
          Completeness
        </span>
        <span className="font-mono text-xs text-zinc-700">{clamped}%</span>
      </div>
      <div
        className="h-1.5 w-full overflow-hidden rounded-full bg-zinc-100"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full rounded-full bg-emerald-500 transition-[width]"
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
